import { parseVariableDesk } from "./parseVariablesCreate";

/**
 * @typedef {import('types/zendesk').ZendeskVariable} ZendeskVariable
 */

/**
 * @param {ZendeskVariable[]} variablesDesk
 * @param {string[]} allowedNames
 */


export const parseVariablesDeskEdit = (variablesDesk, allowedNames, validIds) => {
    /**
     * @type {ZendeskVariable[]}
     */
   variablesDesk.forEach(variable => {
        if (!variable?.zendesk_ticket_field) return;
        const exists = validIds.find(value => 
            value.zendesk_ticket_field && 
            value.zendesk_ticket_field.title === variable.zendesk_ticket_field.title
        );

        if (!exists || exists.zendesk_ticket_field === null) {
            variable.zendesk_ticket_field = null;
        }
    });

    const filteredVariables = variablesDesk.filter(variable => {
        return variable && allowedNames?.includes(variable.name);
    });

    return filteredVariables.map(parseVariableDesk).filter(variable => variable !== null);
};